/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-useless-return */
import { useLazyRemoveFlightByIdQuery } from '@/slices/flightData/apis/flightDataApi';
import { setOrderId } from '@/slices/global/globalSlice';
import {
} from '@/slices/selectedFlight/slices/selectedFlightSlice';
import { style } from '@/styles/globals';
import { convertMoney } from '@/utils/convertMoney';
import { useAppDispatch, useAppSelector } from '@/utils/hook';
import { pr } from '@/utils/pxToRem';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material';
import { styled } from '@mui/system';
import { get, isNil, some } from 'lodash';
import { useRouter } from 'next/router';
import { memo, useEffect, useState } from 'react';
import ReserveErrorDialogContainer from '../ReserveErrorDialog';
import VerifyFlightModal from '../VerifyFlightModal';

const BottomNotification = ({
  onReserveOrder,
}: // extractPriceDiffResponse,
{
  onReserveOrder: (disableRedirect?: boolean) => void;
  // extractPriceDiffResponse: any
}) => {
  const dispatch = useAppDispatch();
  const { push, asPath } = useRouter();
  const [removeFlightById] = useLazyRemoveFlightByIdQuery();

  const [orderCodeProcessed, setOrderCodeProcessed] = useState(false);
  const reserveResponse = useAppSelector(
    (state) => state.global.reserveResponse,
  );
  const verifyFlightError = useAppSelector(
    (state) => state.global.verifyFlightError,
  );

  let orderId = useAppSelector((state) => state.global.orderId);
  if (get(reserveResponse, 'orders[0]') && !orderCodeProcessed && !asPath.includes('trip-detail')) {
    const order = get(reserveResponse, 'orders[0]');
    if (order && order.id) {
      orderId = order.id;
      dispatch(setOrderId({ orderId }));
      push(
        {
          pathname: '/pay',
          query: {
            phone: order.contactPhone,
            email: order.contactEmail,
            value: order.amount,
            code: order.code,
            id: orderId,
          },
        },
        undefined,
        { shallow: true },
      );
    }
    setOrderCodeProcessed(true);
  }

  const [priceDiffDialogOpen, setPriceDiffDialogOpen] = useState(false);
  const [errorDialogOpen, setErrorDialogOpen] = useState(false);
  const { reserveOrderError } = useAppSelector((state) => state.global);

  useEffect(() => {
    if (reserveOrderError) {
      const {
        flightId, from, to, date, airline,
      } = reserveOrderError;
      if (
        !some([flightId, from, to, date, airline], isNil)
      ) {
        removeFlightById({
          id: flightId,
          body: {
            from,
            to,
            date,
            airline,
          },
        });
      }
      if (reserveOrderError.priceDiff && !priceDiffDialogOpen) {
        setPriceDiffDialogOpen(true);
      }
      if (!reserveOrderError.priceDiff && !errorDialogOpen) {
        setErrorDialogOpen(true);
      }
    }
  }, [reserveOrderError]);

  if (verifyFlightError) {
    return <VerifyFlightModal verifyFlightError={verifyFlightError} />;
  }

  return (
    reserveOrderError ? (
      (reserveOrderError.priceDiff && reserveOrderError.priceDiff.oldPrice !== reserveOrderError.priceDiff.newPrice) ? (
        <StyledDialog
          open={priceDiffDialogOpen}
          onClose={() => {
            setPriceDiffDialogOpen(false);
            push('/', undefined, { shallow: true });
          }}
          PaperProps={{
            style: {
              padding: pr`16px`,
            },
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <StyledDialogTitle
            id="alert-dialog-title"
            sx={{ textAlign: 'center' }}
          >
            <Typography
              variant="subtitle2"
              color={style.color.black1}
            >
              Giá cước đã thay đổi
            </Typography>
          </StyledDialogTitle>
          <StyledDialogContent>
            <DialogContentText id="alert-dialog-description">
              <Stack>
                <Typography variant="captionRegular">
                  Tổng giá cước đã được thay đổi từ
                  {' '}
                  <strong>
                    {convertMoney(reserveOrderError.priceDiff.oldPrice)}
                  </strong>
                  {' '}
                  thành
                  {' '}
                  <strong>
                    {convertMoney(reserveOrderError.priceDiff.newPrice)}
                    .
                  </strong>
                </Typography>
                <Typography variant="caption">
                  Bạn có muốn tiếp tục đặt vé?
                </Typography>
              </Stack>
            </DialogContentText>
          </StyledDialogContent>
          <StyledDialogActions>
            <StyledButton
              style={{
                color: style.color.orange3,
              }}
              variant="text"
              onClick={() => {
                setPriceDiffDialogOpen(false);
                push('/', undefined, { shallow: true });
              }}
            >
              Trở lại
            </StyledButton>
            <StyledButton
              style={{ background: style.color.orange3 }}
              variant="contained"
              onClick={() => {
                setPriceDiffDialogOpen(false);
                onReserveOrder(false);
              }}
            >
              Tiếp tục
            </StyledButton>
          </StyledDialogActions>
        </StyledDialog>
      ) : (
        <ReserveErrorDialogContainer
          errorDialogOpen={errorDialogOpen}
          setErrorDialogOpen={setErrorDialogOpen}
          message={reserveOrderError?.message}
          error={reserveOrderError}
          tab="flight"
        />
      )
    ) : null
  );
};

const StyledDialogTitle = styled(DialogTitle)({
  fontWeight: 'bold',
  padding: 0,
});
const StyledButton = styled(Button)({
  ...style.text.content.bold,
  color: 'white',
  flex: '1 1 1px',
  padding: `${pr`12px`} ${pr`16px`}`,
});
const StyledDialogActions = styled(DialogActions)({
  display: 'flex',
  justifyContent: 'space-between',
  padding: 0,
});
const StyledDialogContent = styled(DialogContent)({
  padding: 0,
  marginTop: pr`16px`,
  marginBottom: '1.5em',
});
const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    background: ${style.color.white4};
    border: 1px solid ${style.color.white3};
    box-sizing: border-box;
    box-shadow: ${style.boxShadow.popupShadow};
    border-radius: 16px;
  }
`;

export default memo(BottomNotification);
